import { getMaterialColors } from '@mews/framework';

export const getThemeOverrides = (primaryColor: string) => {
    const materialColors = getMaterialColors(primaryColor);

    const overrides = {
        decisions: {
            interactive: {
                primary: {
                    default: materialColors.base,
                    hover: materialColors[800],
                    active: materialColors[900],
                },
            },
            borderColor: {
                semantic: {
                    primary: materialColors.base,
                },
            },
        },
    };

    return overrides;
};
